<script>
import CommonMixin from './CommonMixin';

export default {
  name: 'ReviewRoute',
  mixins: [CommonMixin],
};
</script>

<template lang="pug">
PanelContainer.panel(id="reviewpanel", :modal="true")
  ReviewBoxConnected
</template>

<style scoped>
.panel {
  width: 520px;
  flex-shrink: 0;
  margin-right: 100px;
}
</style>
